import React from 'react';
import { NewsArrival } from '@/features/news/components/reader/NewsArrival';
import { useExternalStripeBanners } from '../hooks/societies/useExternalStripeBanners';

/**
 * Bandeau et modale d'arrivée des nouveautés sur l'outil pro.
 *
 * Règle Stripe : tant qu'un bandeau Stripe est affiché, ni modale ni bandeau de
 * nouveautés (le fil, la page et le badge restent accessibles) — la modale
 * apparaîtra une fois le problème réglé. On attend aussi que l'état Stripe soit
 * CHARGÉ avant de décider : sans cela la modale s'ouvrirait une fraction de
 * seconde, serait déclarée présentée, puis disparaîtrait.
 */
export const ProNewsArrival: React.FC = () => {
  const { banners, isResolved } = useExternalStripeBanners();
  return <NewsArrival platform="PRO" blocked={!isResolved || banners.length > 0} />;
};
